import React from 'react';

const AutoplannerProgressMobile = ({ steps, currentStep }) => {
  const total = steps.length;
  const percent = Math.min(100, Math.round(((currentStep + 1) / total) * 100));
  const title = steps[currentStep]?.title || '';

  return (
    <div className="sticky top-0 z-30 border-b bg-white/95 backdrop-blur md:hidden">
      <div className="mx-auto max-w-7xl px-4">
        <div className="py-3">
          <div className="flex items-center justify-between">
            <div className="min-w-0">
              <div className="text-xs text-gray-500">
                Step {currentStep + 1} of {total}
              </div>
              <div className="truncate text-sm font-medium text-gray-900">{title}</div>
            </div>
            <div className="ml-4 w-24">
              <div className="h-2 w-full rounded-full bg-gray-200">
                <div
                  className="h-2 rounded-full bg-blue-600 transition-all"
                  style={{ width: `${percent}%` }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutoplannerProgressMobile;
